import {GetterTree} from "vuex";
import {MoreAboutWidgetState} from "@/apps/MoreAboutWidget/models/more-about-widget-state";
import ICategory from "@/apps/MoreAboutWidget/models/category";
import ISubCategory from "@/apps/MoreAboutWidget/models/sub-category";
import IContentItem from "@/apps/MoreAboutWidget/models/content-item";

export default <GetterTree<MoreAboutWidgetState, MoreAboutWidgetState>>{
    selectedCategory(state): ICategory | undefined {
        return state.selectedCategory;
    },

    subCategories(state): ISubCategory[] {
        return state.subCategories;
    },

    selectedSubCategory(state): string {
        return state.selectedSubCategory;
    },

    subContentItems(state): IContentItem[] {
        return state.subContentItems;
    },

    selectCategoryUrl: () => (item: ICategory | ISubCategory) => {
        if (item.url) {
            return item.url;
        }

        let items: ISubCategory[] | IContentItem[];

        items = "subCategories" in item ? item.subCategories : item.contentItems;

        if (items !== null && items.length === 1) {
            return items[0].url;
        }

        return "";
    }
}

